
import { twicifyAirtable } from '~/helpers/twicpics'

export default {
  name: 'Products',
  async asyncData({ $db, app }) {
    const rawCategories = await $db.fetch('categories')
    const categories = rawCategories.map((c) => ({
      ...c,
      imageThumbnail: twicifyAirtable(c.imageThumbnail)
    }))
    return {
      categories,
      products: await $db.fetch('recentProducts', { maxRecords: 100 })
    }
  },
  head() {
    return {
      title: 'La boutique'
    }
  }
}
